if (!customElements.get('rookie-players-tabbar')) {
  class RookieTabbar extends HTMLElement {
    constructor() {
      super();

      this._onClick = this.onClick.bind(this);

      const firstId = this.getAttribute('data-first-tab-id');
      for (const element of document.querySelectorAll(`[data-for-tab-id="${firstId}"]`)) {
        element.classList.add('tab-content--show');
      }

      // 恢复切换 Tab 记录
      if (this.isBackForwardNavigation()) {
        const previousTabId = window.localStorage.getItem('rookie_players_page_previous_tab_id');
        this.handleTapTo(previousTabId);
      }
    }

    // 检查是否通过后退/前进访问
    isBackForwardNavigation() {
      if (window.performance && performance.getEntriesByType) {
        const navigationEntries = performance.getEntriesByType('navigation');
        if (navigationEntries.length > 0) {
          const navigationEntry = navigationEntries[0];
          // 新的 type 属性值
          // 'navigate'：正常访问
          // 'reload'：刷新
          // 'back_forward'：后退/前进
          // 'prerender'：预渲染
          return navigationEntry.type == 'back_forward';
        }
      } else if (performance.navigation) {
        // 回退到旧 API
        return performance.navigation.type == 2;
      }
      return false;
    }

    connectedCallback() {
      this.querySelector('[data-tab-list]')?.addEventListener('click', this._onClick);
    }

    disconnectedCallback() {
      this.querySelector('[data-tab-list]')?.removeEventListener('click', this._onClick);
    }

    onClick(e) {
      /** @type {HTMLElement} */
      const target = e.target;
      if (target.hasAttribute('data-tab-list-item')) {
        const id = target.getAttribute('data-tab-id');
        window.localStorage.setItem('rookie_players_page_previous_tab_id', id);
        this.handleTapTo(id, target, true);
      }
    }

    /**
     * 
     * @param {string | number} id 
     * @param {HTMLElement?} target 
     */
    handleTapTo(id, el, autoScroll = false) {
      const target = el ?? document.querySelector(`[data-tab-list-item][data-tab-id="${id}"]`);
      target.parentElement.querySelector('.active').classList.remove('active');
      target.classList.add('active');
      for (const element of document.querySelectorAll(`[data-for-tab-id]`)) {
        if (element.getAttribute('data-for-tab-id') == id) {
          // Show
          element.classList.add('tab-content--show');
        } else {
          // Hide
          element.classList.remove('tab-content--show');
        }
      }
      // 自动滚动
      if (autoScroll) {
        const announcementBar = document.querySelector('announcement-bar');
        const header = document.querySelector('sticky-header');
        const tabbarHeight = this.clientHeight;
        const announcementBarHeight = (announcementBar?.clientHeight ?? 0) + 1;
        const headerHeight = (header.clientHeight ?? 0) + 1;
        let offsetTop = this.previousElementSibling.offsetTop - tabbarHeight;
        // 头部吸顶模块的高度
        let alwaysStickyHeight = 0;
        // 头部不吸顶模块的高度
        let notAlwaysStickyHeight = 0;
        announcementBar.isAlwaysSticky ? alwaysStickyHeight += announcementBarHeight : notAlwaysStickyHeight += announcementBarHeight;
        header.isAlwaysSticky ? alwaysStickyHeight += headerHeight : notAlwaysStickyHeight += headerHeight;

        console.log(alwaysStickyHeight, notAlwaysStickyHeight)
        const toScrollTop = (offsetTop > window.scrollY)
          ? offsetTop
          : offsetTop - notAlwaysStickyHeight;
        if (Math.abs(offsetTop - window.scrollY) > notAlwaysStickyHeight) {
          window.scrollTo({
            top: toScrollTop,
            behavior: 'smooth',
          });
        }
      }
    }
  }

  customElements.define('rookie-players-tabbar', RookieTabbar);
}